import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { ContainerHeight } from '@yard/app/api'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

type Props<M extends boolean = false> = {
  onChange: (containerHeight: M extends true ? ContainerHeight[] : ContainerHeight) => void
} & TomAutoCompleteProps<ContainerHeight, M>

export const ContainerHeightAutoComplete = observer(
  <M extends boolean = false>(props: Props<M>) => {
    const { t } = useTranslate()
    const { dataCy, defaultValue, label, onChange } = props

    const [options] = useState<ContainerHeight[]>(Object.values(ContainerHeight))

    return (
      <TomAutoComplete
        {...props}
        dataCy={dataCy ?? 'container-height-autocomplete'}
        label={label ?? t('containerHeight', 'Container Height')}
        options={options}
        defaultValue={defaultValue}
        enablePortal
        placeholder={t('selectContainerHeight', 'Select container height')}
        onChangeEntity={entity =>
          onChange(entity as M extends true ? ContainerHeight[] : ContainerHeight)
        }
      />
    )
  },
)
